module.exports = __webpack_public_path__ + "media/images/icons/twotone/rest-797a7293f0611b676e5fa761cc9f8834.svg";